import styles from './DropDownWithPictures.styl';
import React from "react";

function DropDownWithPictures(props) {
let classes =  styles.dropdown
	if(!props.active) classes = styles.dropdown + ' ' + styles.noActive
	return (
		<div style={props.styles}>
			<div style={{width: props.width}} className={classes}>
				<span style={{paddingLeft :'3px'}}>{props.activeValue}</span>
				{props.active &&
					<div style={{width: '200px'}} className={styles['dropdown-content']}>
						{props.items && props.items.length > 0
							?
							props.items.map((item, index) =>
								<div key={index} id={index} className={styles.line} onClick={()=>(props.click && props.click(item.title))}>
									<span className={styles.option} >
										<span className={styles[item.img]}/>
										{item.title}</span>
								</div>
							)
							:
							<div className={styles.line}>
								<span className={styles.option}>Выбрать</span>
							</div>
						}
					</div>
				}

			</div>
		</div>
	);

}

export default DropDownWithPictures;




// WEBPACK FOOTER //
// ./src/react/ui/features/DropDownWithPictures.jsx